<template>
  <div class="record-detail-wrapper" v-wechat-title="title">
    <div class="record-back" :class="{'questionnaire': detailType == 2}"></div>
    <div class="record-main" v-if="dataDone">
      <!-- 处方状态 -->
      <div class="script-status" v-if="detailType == 3">
        <div class="status-bar ing" v-if="formData.status == 4">处方审核中，请稍后查看</div>
        <div class="status-bar unpass" v-else-if="formData.status == 5">处方审核未通过<span v-if="formData.reason">，{{formData.reason}}</span></div>
      </div>
      <div class="doc-card" v-if="detailType != 1">
        <div class="avatar"><img :src="formData.avatar"></div>
        <div class="doc-info">
          <div class="name">{{formData.doc_username}}<span>{{formData.title | jobTitleFilter}}</span></div>
          <div class="job">{{formData.p_dep_title}} | {{formData.dep_title}}</div>
        </div>
      </div>
      <prescription-paper :script-data="formData" :role="userInfo.role" :from="'record'" v-if="detailType == 3" />
      <questionnaire :form-data="formData" v-else-if="detailType == 2" />
      <first-record :form-data="formData" v-else-if="detailType == 1" />
      <div class="back"><button class="back-button" @click="back">返回</button></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .record-detail-wrapper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;
    .record-back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: @xile;
      z-index: 1;
      &.questionnaire{
        background: @wenzhen;
      }
    }
    .record-main{
      position: relative;
      z-index: 10;
      padding: 16px 8px 0;
      .script-status{
        .status-bar{
          position: relative;
          padding: 8px 20px 6px 26px;
          margin-bottom: 12px;
          border-radius: 6px;
          font-size: 12px;
          line-height: 18px;
          &::after{
            content: '';
            position: absolute;
            left: 16px;
            top: 14px;
            width: 4px;
            height: 4px;
            border-radius: 50%;
          }
          &.ing{
            background: #FCF1DD;
            color: #ED9E1A;
            &::after{
              background: #ED9E1A;
            }
          }
          &.unpass{
            background: #FCE6E7;
            color: #EA595D;
            &::after{
              background: #EA595D;
            }
          }
        }
      }
      .doc-card{
        padding: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #FFF;
        border-radius: 6px;
        box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
        .avatar{
          width: 48px;
          height: 48px;
          overflow: hidden;
          border-radius: 50%;
          flex-shrink: 0;
          img{
            width: 100%;
          }
        }
        .doc-info{
          margin-left: 12px;
          .name{
            font-size: 16px;
            line-height: 16px;
            color: @black;
            font-weight: bold;
            span{
              margin-left: 8px;
              font-size: 14px;
              color: #999;
              font-weight: normal;
            }
          }
        }
        .job{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          margin-top: 8px;
        }
      }
      .back{
        padding: 24px 0 12px;
        .back-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import prescriptionPaper from '@/components/Common/prescription'
  import questionnaire from '@/components/Common/questionnaire'
  import firstRecord from '@/components/Common/firstRecord'
  export default {
    data() {
      return {
        dataDone: false,
        detailType: parseInt(this.$route.query.type),
        formData: {},
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo
      },
      title() {
        switch(this.detailType) {
          case 1: return '病历详情';break;
          case 2: return '问诊单详情';break;
          case 3: return '病历详情';break;
        }
      }
    },
    components: {
      prescriptionPaper,
      questionnaire,
      firstRecord
    },
    created() {
      switch(this.detailType) {
        case 1: {
          // 获取首诊信息数据
          this.$root.post('/getFirstDetail', {
            id: this.$route.query.id
          }).then(data => {
            this.dataDone = true;
            this.formData = data;
          })
        }break;
        case 2: {
          // 获取问诊单数据
          this.$root.post('/getPatientAnswer', {
            id: this.$route.query.id
          }).then(data => {
            console.log(data);
            this.dataDone = true;
            this.formData = data;
          })
        }break;
        case 3: {
          // 获取处方数据
          this.$root.post('/getPreDetail', {
            id: this.$route.query.id,
            type: 1,
          }).then(data => {
            console.log(data);
            this.dataDone = true;
            this.formData = data;
          })
        }break;
      }
    },
    methods: {
      back() {
        this.$router.go(-1);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ConsultingRoom/recordDetail.vue